import el from "@cypherpotato/el";
import page from "page";
import { api } from "../../api";
import { Button, ButtonRow } from "../../components/button";
import { Card, CardContent, CardHeader } from "../../components/card";
import { CommandBar } from "../../components/command-bar";
import { Dashboard, DashboardTitle } from "../../components/dashboard";
import { Dropdown, DropdownItem } from "../../components/dropdown";
import { FormControl, TextInput } from "../../components/form";
import { Icon } from "../../components/icon";
import { Section } from "../../components/layout";
import { ModelBadge } from "../../components/model-icon";
import { DefaultRow, Table, TableActionCell, TableBody, TableCell, TableHeader, TableHeaderActionCell, TableHeaderCell, TableRow } from "../../components/table";
import { CopiableText, MutedText } from "../../components/text";
import { displayAlert } from "../../ui/alert";
import { runOperation } from "../../ui/operation";
import { throttledCall } from "../../ui/throttle";


export default function (ctx) {

    const filter = el.state.create("");
    const gateways = el.state.create(null);

    async function refreshTable() {
        const response = await api.getJson("/api/v1/ai-gateways?" + new URLSearchParams({
            filter: filter.value
        }).toString());
        gateways.value = response.data;
    }

    runOperation("Fetching gateways...", async () => {
        await refreshTable();
    });

    return Dashboard(
        DashboardTitle(
            "AI gateways",
            "Here you can view and manage your AI gateways."
        ),
        Section(
            CommandBar(
                Button(Icon("add-line"), "New AI gateway", {
                    onClick() {
                        page("/dashboard/gateways/create");
                    }
                })
            )
        ),
        Section(
            CommandBar(
                FormControl(null,
                    TextInput("searchInput", "Filter columns...", {
                        onInput(event) {
                            throttledCall(() => {
                                filter.value = event.target.value;
                                refreshTable();
                            }, 300);
                        },
                        value: filter.value
                    })
                )
            )
        ),
        Section(
            Card(
                { class: "bg-card" },
                CardHeader(
                    "My AI gateways"
                ),
                CardContent(
                    el.state.listening([filter, gateways], () => Table(
                        {
                            classList: ["hoverable"],
                        },
                        TableHeader(
                            TableHeaderCell("Id."),
                            TableHeaderCell("Name"),
                            TableHeaderCell("Base model"),
                            TableHeaderCell("Base address"),
                            TableHeaderCell("Slug"),
                            TableHeaderActionCell("Actions")
                        ),
                        TableBody(
                            gateways.value?.map(gateway =>
                                TableRow(
                                    TableCell(
                                        CopiableText(`#${gateway.id.substr(-4)}`, gateway.id)
                                    ),
                                    TableCell(
                                        gateway.name
                                    ),
                                    TableCell(
                                        ModelBadge(gateway.modelName)
                                    ),
                                    TableCell(
                                        gateway.inferenceEndpoint || MutedText("Integrated")
                                    ),
                                    TableCell(
                                        CopiableText(gateway.slug)
                                    ),
                                    TableActionCell(
                                        Button(
                                            Icon("arrow-right-double-line"),
                                            "View",
                                            {
                                                onClick() {
                                                    page(`/dashboard/gateways/${gateway.id}`);
                                                }
                                            }
                                        )
                                    )
                                )
                            )?.nullWhenEmpty() || DefaultRow("No AI gateways found.")
                        )
                    )
                    )
                )
            )
        )
    )
}